<template>
  <div class="add-edit-architect">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">
              {{ edit ? "Edit" : "Add" }} Architect Company
            </h3>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <v-form ref="form" lazy-validation @submit.prevent="save">
              <v-card flat>
                <v-card-text class="px-0 pt-0">
                  <div class="logo mb-3">
                    <v-avatar tile v-if="edit" size="60">
                      <v-img v-if="pickedFile.file" :src="getLogo()" contain />
                      <v-img v-else :src="getLogo()" contain />
                    </v-avatar>
                    <v-avatar
                      tile
                      v-else
                      :color="(!pickedFile.file && 'primary') || 'white'"
                      size="60"
                    >
                      <v-img v-if="pickedFile.file" :src="getLogo()" contain />
                      <v-icon v-else color="white">mdi-camera</v-icon>
                    </v-avatar>
                    <v-btn
                      color="black"
                      fab
                      x-small
                      @click="uploadFile"
                      class="white--text logo-btn"
                      max-width="24"
                      max-height="24"
                      ><v-icon size="14">mdi-pencil</v-icon></v-btn
                    >
                    <input
                      ref="pickFile"
                      class="d-none"
                      type="file"
                      accept="image/*"
                      @change="onFilePick"
                    />
                  </div>
                  <v-text-field
                    v-model="architect.name"
                    label="Company Name"
                    :rules="[v => !!v || 'Company Name is required']"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model="architect.address.add_line_1"
                    label="Address Line 1"
                    :rules="[v => !!v || 'Address Line 1 is required']"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model="architect.address.add_line_2"
                    :rules="[v => !!v || 'Address Line 2 is required']"
                    label="Address Line 2"
                    outlined
                    dense
                  ></v-text-field>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="architect.address.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="px-md-2">
                      <v-autocomplete
                        v-model="architect.address.state"
                        label="State"
                        :rules="[v => !!v || 'State is required']"
                        :items="states"
                        item-text="name"
                        item-value="value"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="architect.address.zip"
                        label="Zip"
                        :rules="[v => !!v || 'Zip is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-1">
                      <v-text-field
                        v-model="architect.website"
                        label="Website"
                        :rules="[
                          v => !!v || 'Website URL is required',
                          v => isURL(v) || 'URL is not valid'
                        ]"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-1">
                      <v-text-field
                        v-model="architect.address.phone"
                        label="Phone"
                        :rules="[v => !!v || 'Phone is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-btn
                color="primary"
                type="submit"
                :loading="saveLoading"
                class="white--text mr-1 px-4"
                depressed
                >Save</v-btn
              >
              <v-btn
                color="black"
                class="px-4"
                :disabled="saveLoading"
                outlined
                depressed
                @click="$emit('close')"
                >Cancel</v-btn
              >
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import states from "@/configs/states.json";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    architectInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      states,
      saveLoading: false,
      pickedFile: {
        name: null,
        file: null
      },
      architect: {
        name: null,
        address: {
          add_line_1: null,
          add_line_2: null,
          city: null,
          state: null,
          zip: null,
          phone: null
        },
        website: null,
        logo: {
          file_type: null,
          base64: null
        }
      }
    };
  },
  created() {
    if (this.architectInfo) {
      this.architect = {
        ...this.architectInfo,
        logo: {
          file_type: null,
          base64: null
        }
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    refresh() {
      this.$emit("refresh");
    },
    getLogo() {
      if (this.pickedFile.file) {
        return URL.createObjectURL(this.pickedFile.file);
      } else if (this.architect.logo_url) {
        return this.architect.logo_url;
      }
    },
    uploadFile() {
      this.$refs.pickFile.click();
    },
    onFilePick(e) {
      const files = [...e.target.files];
      this.pickedFile.name = null;
      this.pickedFile.file = null;
      if (files && files.length) {
        this.pickedFile.name = files[0].name;
        this.pickedFile.file = files[0];

        this.architect.logo.file_type = files[0].type.split("/")[1];

        const reader = new FileReader();

        reader.onloadend = () => {
          this.architect.logo.base64 = reader.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.edit) {
          this.updateArchitectCompany();
        } else {
          this.createArchitectCompany();
        }
      }
    },
    createArchitectCompany() {
      if (this.$refs.form.validate()) {
        const data = { ...this.architect };
        if (this.architect.logo.base64) {
          data.logo.base64 = this.architect.logo.base64.split("base64,")[1];
          this.saveLoading = true;
          this.$store
            .dispatch("architect/createArchitectCompany", data)
            .then(() => {
              this.refresh();
            })
            .finally(() => {
              this.saveLoading = false;
            });
        } else {
          this.$store.commit(
            "setToast",
            {
              message: "Logo is required.",
              type: "error",
              show: true
            },
            { root: true }
          );
        }
      }
    },
    updateArchitectCompany() {
      if (this.$refs.form.validate()) {
        const data = { ...this.architect };

        delete data.logo_url;

        if (this.pickedFile.file) {
          data.logo.base64 = this.architect.logo.base64.split("base64,")[1];
        } else {
          data.logo = {
            file_type: null,
            base64: null
          };
        }

        this.saveLoading = true;
        this.$store
          .dispatch("architect/updateArchitectCompany", data)
          .then(() => {
            this.refresh();
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.browse-btn {
  position: absolute;
  right: 5px;
  bottom: 5px;
}

.logo {
  width: 60px;
  height: 60px;
  position: relative;
  margin: 0 auto;
}

.logo-btn {
  position: absolute;
  right: -12px;
  bottom: -12px;
}
</style>
